module.exports = __webpack_public_path__ + "static/media/undraw_workspace_s6wf.23d0b5a7.svg";